import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import FormSection from "../../formSection/formSection";
import { Button, FormGroup } from "react-bootstrap";
import { imageUploadUrl } from "services/redux/fileUpload/action";
import ModalPop from "../../modal/modal";
import s from "./viewDetails.module.css";
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";

const ViewDetails = ({
    showViewDetailsPopup,
    onClosePopup = () => { },
    invoiceId
}) => {
    const [data, setData] = useState();

    async function fetchData() {
        try {
            const url = `${Config.preSalesList.invoiceDetails}?invoice_id=${invoiceId}`;

            const { data } = await axios.get(url);
            console.log('fetchData', data)
            setData(data?.response?.data);
        } catch {
            console.log('Something went wrong');
        }
    }

    async function downloadInvoicePdf(val) {
        
            if (val) {
                try {
                    const url = `${Config.preSalesList.downloadInvoicePdf}?invoice_id=${invoiceId}`;
    
                    const { data } = await axios.get(url);
                    if(data.response.data !== null){
                        window.open(data.response.data.invoice_pdf);
                    }
                } catch {
                    console.log('Something went wrong');
                }
            }        
      };

    const [isMobile, setIsMobile] = React.useState(false);

    useEffect(() => {
        if (invoiceId)
            fetchData();
    }, []);

    useEffect(() => {
        let windowWidth = window.innerWidth;
        if (windowWidth <= 480) {
            setIsMobile(true);

        }
    }, [isMobile]);


    console.log(isMobile);
    const viewDetails = () => {
        return (
            <div className={s.root}>
                <div className={s.parallel_box}>
                    <div className={s.box}>
                        <h4 className={s.header}>Invoice Details</h4>
                        <p className={s.p}><span className={s.name}>Invoice Number:</span> {'  ' + data?.invoice_number}</p>
                        <p className={s.p}><span className={s.name}>Invoice Date:</span> {'  ' + data?.invoice_date}</p>
                        <p className={s.p}><span className={s.name}>Invoice Due Date:</span> {'  ' + data?.inv_due_date}</p>
                        <p className={s.p}><span className={s.name}>Revenue Nature:</span> {'  ' + data?.revenue_nature}</p>
                        <p className={s.p}><span className={s.name}>Billing Period:</span> {'  ' + data?.billing_period}</p>
                        <p className={s.p}><span className={s.name}>Status:</span> {'  ' + data?.invoice_status}</p>
                        <p className={s.p}><span className={s.name}>Created By:</span> {'  ' + data?.created_by}</p>
                        <p className={s.p}><span className={s.name}>Mode:</span> {'  ' + data?.mode}</p>
                    </div>
                    <div className={s.box}>
                        <h4 className={s.header}>Business Details</h4>
                        <p className={s.p}><span className={s.name}>Business Name:</span> {'  ' + data?.business_name}</p>
                        <p className={s.p}><span className={s.name}>City:</span> {'  ' + data?.city}</p>
                        <p className={s.p}><span className={s.name}>Area:</span> {'  ' + data?.pincode}</p>
                        <p className={s.p}><span className={s.name}>Zone:</span> {'  ' + data?.address}</p>
                        <p className={s.p}><span className={s.name}>Address:</span> {'  ' + data?.address}</p>
                        <p className={s.p}><span className={s.name}>Pincode:</span> {'  ' + data?.pincode}</p>
                    </div>
                </div>
                <div className={s.parallel_box}>
                    <div className={s.box}>
                        <h4 className={s.header}>Invoice Amount Details</h4>
                        <p className={s.p}><span className={s.name}>Principal Amount:</span> {'  ' + data?.principal_amount}</p>
                        <p className={s.p}><span className={s.name}>Freight Charges:</span> {'  ' + data?.freight_charges}</p>
                        <p className={s.p}><span className={s.name}>SGST Amount:</span> {'  ' + data?.sgst_amount}</p>
                        <p className={s.p}><span className={s.name}>CGST Amount:</span> {'  ' + data?.cgst_amount}</p>
                        <p className={s.p}><span className={s.name}>IGST Amount:</span> {'  ' + data?.igst_amount}</p>
                        <p className={s.p}><span className={s.name}>Total Amount:</span> {'  ' + data?.total_amount}</p>
                    </div>
                </div>
                 { data?.invoice_items.length > 0 &&
                <h4 className={s.table_header}>Line Items</h4>}
                {!isMobile && data?.invoice_items.length > 0 && <div className={s.table}>

                    <div className={s.table_row}>
                        <p className={s.name}>Sr. No.</p>
                        <p className={s.name}>HSN Code</p>
                        <p className={s.name}>Item Desription</p>
                        <p className={s.name}>Quantity</p>
                        <p className={s.name}>UOM</p>
                        <p className={s.name}>Unit rate</p>
                        <p className={s.name}>IGST</p>
                        <p className={s.name}>CGST</p>
                        <p className={s.name}>SGST</p>
                        <p className={s.name}>Amount</p>
                    </div>
                    {data?.invoice_items.length > 0 && data?.invoice_items.map((item, index) => (
                        <div className={s.table_row}>
                            <p>{index + 1}</p>
                            <p>{item?.hsn_code}</p>
                            <p>{item?.item_description}</p>
                            <p>{item?.quantity}</p>
                            <p>{item?.uom}</p>
                            <p>{item?.unit_rate}</p>
                            <p>{item?.igst_amt}</p>
                            <p>{item?.cgst_amt}</p>
                            <p>{item?.sgst_amt}</p>
                            <p>{item?.total_amount}</p>
                        </div>
                    ))}

                </div>}

                {isMobile && data?.invoice_items.length > 0 && <div className={s.table}>
                    {data?.invoice_items.length > 0 && data?.invoice_items.map((item, index) => (
                        <div className={s.box}>
                            <p className={s.p} ><span className={s.name}>Sr. No:</span>{' ' + index + 1}</p>
                            <p className={s.p}><span className={s.name}>HSN Code:</span>{' ' + item?.hsn_code}</p>
                            <p className={s.p}><span className={s.name}>Item Desription:</span>{' ' + item?.item_description}</p>
                            <p className={s.p}><span className={s.name}>Quantity:</span>{' ' + item?.quantity}</p>
                            <p className={s.p}><span className={s.name}>UOM:</span>{' ' + item?.uom}</p>
                            <p className={s.p}><span className={s.name}>Unit rate:</span>{' ' + item?.unit_rate}</p>
                            <p className={s.p}><span className={s.name}>IGST:</span>{' ' + item?.igst_amt}</p>
                            <p className={s.p}><span className={s.name}>CGST:</span>{' ' + item?.cgst_amt}</p>
                            <p className={s.p}><span className={s.name}>SGST:</span>{' ' + item?.sgst_amt}</p>
                            <p className={s.p}><span className={s.name}>Amount:</span>{' ' + item?.total_amount}</p>
                        </div>
                    ))}
                </div>}



                { data?.payments.length > 0&& <h4 className={s.table_header}>Payment Details</h4>}
                {
                    !isMobile && data?.payments.length > 0 && <div className={s.table}>

                        <div className={s.table_row} style={{ gridTemplateColumns: '1fr 2fr 2fr 2fr 2fr 1fr 1fr' }}>
                            <p className={s.name}>Sr. No.</p>
                            <p className={s.name}>Reference No.</p>
                            <p className={s.name}>Amount Received</p>
                            <p className={s.name}>Retention Amount</p>
                            <p className={s.name}>Grand Total Amount</p>
                            <p className={s.name}>TDS</p>
                            <p className={s.name}>Mode</p>
                        </div>
                        {data?.payments.length > 0 && data?.payments.map((item, index) => (
                            <div className={s.table_row} style={{ gridTemplateColumns: '1fr 2fr 2fr 2fr 2fr 1fr 1fr' }}>
                                <p>{index + 1}</p>
                                <p>{item?.hsn_code}</p>
                                <p>{item?.item_description}</p>
                                <p>{item?.quantity}</p>
                                <p>{item?.uom}</p>
                                <p>{item?.unit_rate}</p>
                                <p>{item?.igst_amt}</p>
                            </div>
                        ))}
                    </div>
                }
                { isMobile && data?.payments.length > 0 && <div className={s.table}>
                {data?.payments.length > 0 && data?.payments.map((item, index) => (
                        <div className={s.box}>
                            <p className={s.p} ><span className={s.name}>Sr. No:</span>{' ' + index + 1}</p>
                            <p className={s.p}><span className={s.name}>Reference No:</span>{' ' + item?.hsn_code}</p>
                            <p className={s.p}><span className={s.name}>Amount Received:</span>{' ' + item?.item_description}</p>
                            <p className={s.p}><span className={s.name}>Retention Amount:</span>{' ' + item?.quantity}</p>
                            <p className={s.p}><span className={s.name}>Grand Total Amount:</span>{' ' + item?.uom}</p>
                            <p className={s.p}><span className={s.name}>TDS:</span>{' ' + item?.unit_rate}</p>
                            <p className={s.p}><span className={s.name}>Mode:</span>{' ' + item?.igst_amt}</p>
                        </div>
                    ))}
                </div>}





                { data?.credit_note_data.length > 0  && <h4 className={s.table_header}>Credit Note Details</h4>}
                {
                    !isMobile && data?.credit_note_data.length > 0 && <div className={s.table}>

                        <div className={s.table_row} style={{ gridTemplateColumns: '1fr 2fr 1fr 2fr 2fr 2fr 2fr 1fr' }}>
                            <p className={s.name}>Sr. No.</p>
                            <p className={s.name}>CN Number.</p>
                            <p className={s.name}>CN Date</p>
                            <p className={s.name}>Principal Amount</p>
                            <p className={s.name}>IGST Amount</p>
                            <p className={s.name}>CGST Amount</p>
                            <p className={s.name}>SGST Amount</p>
                            <p className={s.name}>Amount</p>
                        </div>
                        {data?.credit_note_data.length > 0 && data?.credit_note_data.map((item, index) => (
                            <div className={s.table_row} style={{ gridTemplateColumns: '1fr 2fr 1fr 2fr 2fr 2fr 2fr 1fr' }}>
                                <p>{index + 1}</p>
                                <p>{item?.cn_number}</p>
                                <p>{item?.cn_date}</p>
                                <p>{item?.principal_amount}</p>
                                <p>{item?.igst_amount}</p>
                                <p>{item?.cgst_amount}</p>
                                <p>{item?.sgst_amount}</p>
                                <p>{item?.amount}</p>
                            </div>
                        ))}
                    </div>
                }
                { isMobile && data?.credit_note_data.length > 0 && <div className={s.table}>
                {data?.credit_note_data.length > 0 && data?.credit_note_data.map((item, index) => (
                    <div className={s.box}>
                    <p className={s.p} ><span className={s.name}>Sr. No:</span>{' ' + index + 1}</p>
                    <p className={s.p}><span className={s.name}>CN Number.:</span>{' ' + item?.cn_number}</p>
                    <p className={s.p}><span className={s.name}>Amount Received:</span>{' ' + item?.cn_date}</p>
                    <p className={s.p}><span className={s.name}>Retention Amount:</span>{' ' + item?.principal_amount}</p>
                    <p className={s.p}><span className={s.name}>Grand Total Amount:</span>{' ' + item?.igst_amount}</p>
                    <p className={s.p}><span className={s.name}>TDS:</span>{' ' + item?.cgst_amount}</p>
                    <p className={s.p}><span className={s.name}>Mode:</span>{' ' + item?.sgst_amount}</p>
                    <p className={s.p}><span className={s.name}>Mode:</span>{' ' + item?.amount}</p>
                </div>
                    
                    
                ))}


            </div >}
          
            </div>
            
        );
        
    };

    return (
        <ModalPop
            title={"View Details"}
            show={showViewDetailsPopup}
            handleModalHide={onClosePopup}
        >
            <div className="col-2">
                 <button className="btn btn-sm btn-primary" onClick={() => {
              downloadInvoicePdf(true);
            }}>Download</button>
                </div>
            <Fragment>
                <FormSection>
                    {viewDetails()}
            </FormSection>
            </Fragment>
        </ModalPop>
    );
};

ViewDetails.propTypes = {
    data: PropTypes.any,
    handleValue: PropTypes.func,
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            imageUploadUrl,
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(ViewDetails);
